import {
  AdminBusinessListItem,
  AdminBusinessListPage,
  AdminExtendSubscriptionResult,
} from "../../../interfaces/AdminBusinessListObject";

// contents (already coerceSingle'd to the page object) -> AdminBusinessListPage.
// Null-guards only; the payload is already camelCase.

const toStr = (value: unknown): string =>
  value === undefined || value === null ? "" : String(value);

const toNullable = (value: unknown): string | null =>
  value === undefined || value === null || value === "" ? null : String(value);

const toCount = (value: unknown): number => Number(value ?? 0) || 0;

export function convertAdminBusinessListItem(
  raw: Record<string, unknown>
): AdminBusinessListItem {
  return {
    businessId: toStr(raw?.businessId),
    businessName: toStr(raw?.businessName),
    creatorId: toStr(raw?.creatorId),
    ownerId: toNullable(raw?.ownerId),
    ownerContactEmail: toNullable(raw?.ownerContactEmail),
    ownerContactPhone: toNullable(raw?.ownerContactPhone),
    subscriptionEnd: toNullable(raw?.subscriptionEnd),
    isOnboarded: raw?.isOnboarded === true,
  };
}

export function convertAdminBusinessListPage(
  raw: Record<string, unknown>
): AdminBusinessListPage {
  const rows = Array.isArray(raw?.content) ? raw.content : [];
  return {
    content: rows.map((row) =>
      convertAdminBusinessListItem(row as Record<string, unknown>)
    ),
    page: toCount(raw?.page),
    size: toCount(raw?.size),
    totalElements: toCount(raw?.totalElements),
    totalPages: toCount(raw?.totalPages),
  };
}

// contents (already coerceSingle'd to the single result object) ->
// AdminExtendSubscriptionResult. The sample response carries both
// previousSubscriptionEnd/newSubscriptionEnd and
// subscriptionPreviousEnd/subscriptionNewEnd for the same values - prefer
// the unprefixed pair, fall back to the subscription-prefixed one.
export function convertAdminExtendSubscriptionResult(
  raw: Record<string, unknown>
): AdminExtendSubscriptionResult {
  return {
    businessId: toStr(raw?.businessId),
    businessName: toStr(raw?.businessName),
    daysExtended: toCount(raw?.daysExtended),
    previousSubscriptionEnd: toNullable(
      raw?.previousSubscriptionEnd ?? raw?.subscriptionPreviousEnd
    ),
    newSubscriptionEnd: toNullable(
      raw?.newSubscriptionEnd ?? raw?.subscriptionNewEnd
    ),
    subscriptionId: toNullable(raw?.subscriptionId),
  };
}
